import axiosInstance from "./axiosInstance";

const storageApi = {
    createStorage: (name, userId) =>
        axiosInstance.post("/storage", { name, userId }),

    deleteStorage: (storageId, userId) =>
        axiosInstance.delete(`/storage/${storageId}`, {
            data: { userId },
        }),

    updateStorage: (storageId, userId, newName) =>
        axiosInstance.put(`/storage/${storageId}`, { userId, newName }),

    getUserStorages: (userId) =>
        axiosInstance.get(`/storages/${userId}`),
};

export default storageApi;
